import React, { useEffect, useState } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { editPaymentScale, getPaymentScaleAdmin } from '../../../../../pages/Dashboard/Api/Admin/Admin'
import { MdInfoOutline } from 'react-icons/md'
import toast from 'react-hot-toast'

interface Props {
    show: boolean
    onHide: () => void
}

export const EditPaymentScaleModal = ({ show, onHide }: Props) => {
    const [paymentScaleInfo, setPaymentScaleInfo] = useState('')

    const getPaymentScaleinfo = async () => {
        let paymentScale = await getPaymentScaleAdmin();
        setPaymentScaleInfo(paymentScale ?? '')
    }


    const handleSubmit = async () => {
        try {
            let result = await editPaymentScale({ newContent: paymentScaleInfo })
            toast.success('Escala de pagos actualizada correctamente')
            onHide();
            console.log(result)
        } catch (error) {
            console.log(error)
        }


    }

    useEffect(() => {
        getPaymentScaleinfo()
    }, [])



    return (
        <Modal show={show} onHide={onHide} centered size='lg'>

            <Modal.Header closeButton>
                <Modal.Title>Explicación Escala de Pagos</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                
                <div>
                    <span className='text-primary text-sm'>Configura la explicación de la escala de pagos para los usuarios.</span>
                </div>
                <div className="mt-3">
                    <textarea className="form-control customDarkInput" value={paymentScaleInfo} onChange={(e) => setPaymentScaleInfo(e.target.value)} style={{ minHeight: '500PX' }}></textarea>
                </div>
                <div className='my-4'>
                    <MdInfoOutline size={20} className="text-warning" />
                    <span className="mx-2 text-xs" style={{ fontSize: '15px' }}>
                        Si no se brinda una explicación, el botón "Escala de pago" no será mostrado a los usuarios en el panel de carga.
                    </span>
                </div>
                <div className="d-flex justify-content-between">
                    <div>
                        <button className='btn btn-dark' onClick={() => setPaymentScaleInfo('')}>Limpiar</button>
                    </div>
                    <div className="d-flex gap-2 justify-content-end">
                        <button className='btn btn-dark mx-2' onClick={() => onHide()}>Cancelar</button>
                        <button className='btn btn-primary mx-2' onClick={handleSubmit}>Guardar</button>
                    </div>
                </div>

            </Modal.Body>
        </Modal >
    )
}
